/** @file findDrawable: a drawable of the puppet by id, with its index, or NOT_FOUND. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import type { Drawable } from '@zilo/pose3d-format/types/drawable';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';
import { throwError } from '@zilo/pose3d-std/errors/throwError';

/** The drawable `id` and its index in `puppet.drawables`; `NOT_FOUND` at `path` (hint: the ids) otherwise. */
export function findDrawable(puppet: Pick<Puppet, 'drawables'>, id: string, path = '/input/drawable'): { index: number; drawable: Drawable } {
  const index = puppet.drawables.findIndex((d) => d.id === id);
  const drawable = puppet.drawables[index];
  if (drawable !== undefined) return { index, drawable };
  return throwError(ERROR_CODES.NOT_FOUND, { drawable: id }, { path, hint: `drawables: ${puppet.drawables.map((d) => d.id).join(', ')}` });
}
